import Chart from "react-apexcharts";

const CurveChart = ({
    xAxisData,
    yAxisData,
    height,
    width,
    dataName,
  }) => {
    const defaultSeries = [{ name: dataName, data: yAxisData }];
    const options = {
      chart: { background: "", toolbar: { show: false } },
      xaxis: {
        categories: xAxisData,
        labels: { show: false },
        axisTicks: { show: false },
        axisBorder: { show: false },
      },
      fill: { colors: ["rgba(30, 181, 100, 1)"] },
      colors:["rgba(30, 181, 100, 1),rgb(30, 181, 100),rgb(30, 181, 100)"],
      stroke: { curve: 'smooth' },
      dataLabels: { enabled: false },
      yaxis: { show: false },
      plotOptions: { bar: { borderRadius: 7, columnWidth: 20 } },
      grid: { show: false },
      tooltip: { enabled: false },
    };
    return (
      <Chart
        options={options}
        series={defaultSeries}
        height={height}
        width={width}
        type="line"
      />
    );
};

export default CurveChart;